import styled from "styled-components";

export const Container = styled.article`
  margin-bottom: 30px;
  max-height: 103vh;
  overflow: hidden;
  position: relative;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    margin-bottom: 50px;
  }
`

export const GradientBottom = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 10%;
  pointer-events: none;
  background: linear-gradient(
    0deg,
    #000000 1%,
    rgba(0, 0, 0, 0.7) 40%,
    rgba(131, 131, 131, 0) 100%
  );

  ${({ theme }) => theme.old.breakpoints.isTab} {
    height: 30%;
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    height: 0%;
  }
`

export const GradientTop = styled.div`
  ${({ theme }) => theme.old.breakpoints.isMobile} {
    position: absolute;
    height: 25%;
    width: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      #000000 1%,
      rgba(0, 0, 0, 0.7) 40%,
      rgba(131, 131, 131, 0) 100%
    );
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    height: 0%;
  }
`
